module.exports = __webpack_public_path__ + "media/images/places/preto-imperio-bfa31466fcc4f2949cc0afc402cce745.jpg";